<script>
import { mapGetters } from 'vuex'
import TruncatedList from '@/components/general/truncated-list.vue'

export default {
  name: 'ClientOverviewTable',
  components: { TruncatedList },
  data() {
    return {
      headers: [],
      search: '',
    }
  },
  computed: {
    ...mapGetters({
      flatAccessTree: 'auth/flatAccessTree',
    }),
    computedHeaders() {
      return this.headers.filter((x) => x.display)
    },
  },
  created() {
    this.initHeaders()
  },
  methods: {
    initHeaders() {
      this.headers = [
        {
          text: this.$t('clientOverview.tableClientColumn'),
          value: 'clientName',
          display: true,
          sortable: true,
        },
        {
          text: this.$t('clientOverview.tableLocationsColumn'),
          value: 'locations',
          display: true,
          sortable: true,
        },
        {
          text: this.$t('clientOverview.tableClientGroupColumn'),
          value: 'clientGroupName',
          display: true,
          sortable: true,
        },
      ]
    },
    selectClient(client) {
      this.$emit('selectClient', client)
    },
  },
}
</script>

<template>
  <v-data-table
    id="client-location-group-table"
    :headers="computedHeaders"
    :items="flatAccessTree"
    :items-per-page="10"
    :search="search"
    :sort-by="['clientGroupName', 'clientName']"
    :sort-desc="[false]"
    color="blue"
    :class="['rounded-xl cl-elevation pt-2 row-pointer']"
    @click:row="selectClient"
  >
    <template v-slot:top>
      <v-text-field
        v-model="search"
        clearable
        prepend-inner-icon="mdi-magnify"
        :label="$t('input.searchLabel')"
        class="mx-4"
      ></v-text-field>
    </template>

    <template v-slot:[`item.locations`]="{ item }">
      <TruncatedList
        :items="item.locations.map((x) => x.locationName)"
        class="locations-list"
        chips
        small
        label
        :limit="1"
      />
    </template>
  </v-data-table>
</template>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
